import { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Card,
  Stack,
  Divider,
  Paper, 
} from "@mui/material";
import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import HomepageHeader from "../../components/UI/organisms/header/Header";
import { useNavigate, useLocation } from 'react-router-dom';
import { getAuth, signOut } from 'firebase/auth';
import app from '../../backend/firebaseConfig';

// Import Functions
import { fetchUserDetails } from "../../components/functions/fetchUserDetails";

const Unauthorized = () => {
    const navigate = useNavigate();
  const location = useLocation();
  const auth = getAuth(app);
  
  const { from, userRole, requiredRoles } = location.state || {};
  const [userDetails, setUserDetails] = useState(null);

  // UseEffects
  useEffect(() => {
    const details = fetchUserDetails(setUserDetails);
    return () => {
      details && details();
    };
  }, []);
  
  const handleGoBack = () => {
    if (from) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };
  return (
    <Box sx={{ backgroundColor: "#fdf9f3", minHeight: "100vh" }}>
      {/* HEADER */}
      <HomepageHeader/>

      {/* MAIN CONTENT */}
      <Box
        sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: {
              xs: "120px 8px 8px 8px",
              sm: "120px 24px 24px 24px",
              md: "120px 24px 24px 24px",
              lg: "120px 24px 24px 24px",
              xl: "120px 24px 24px 24px",
            },
            pt: 15,
          }}
      >
        <Card
          sx={{
            width: "100%",
            maxWidth: 700,
            p: {
              xs: "40px 40px",
              sm: "40px 40px",
              md: "40px",
              lg: "40px",
              xl: "40px",
            },
            borderRadius: 3,
            boxShadow: "0px 2px 10px rgba(0,0,0,0.2)",
          }}
        >
          <Stack alignItems="center" spacing={2}>
            {/* Warning Icon */}
            <Box
              sx={{
                backgroundColor: "#f6efe3",
                width: 80,
                height: 80,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <WarningAmberRoundedIcon
                sx={{ color: "#c8a76f", fontSize: 40 }}
              />
            </Box>

            {/* Title */}
            <Typography variant="h4" sx={{ fontWeight: 700, color: "#C5A572", fontSize: "24px" }}>
              Access Denied
            </Typography>
            <Typography sx={{ color: "#555", textAlign: "center" }}>
              You don’t have permission to access this page.
            </Typography>

            {/* Access Details */}
            <Paper
              variant="outlined"
              sx={{
                backgroundColor: "#f9f9f9",
                borderRadius: 2,
                width: "100%",
                p: 2.5,
                mt: 2,
              }}
            >
              <Typography fontWeight={600}>Access Details:</Typography>
              <Divider sx={{ my: 1 }} />
              <Typography variant="body1">
                <strong>{!userDetails?.role ? "Not logged in" : "Your Role:"}</strong> {userDetails?.role || null}
              </Typography>
            </Paper>

            {/* Buttons */}
            <Stack 
            width="100%"
            direction={{
              xs: "column",
              sm: "row",
              md: "row",
              lg: "row",
              xl: "row"
            }} spacing={2} sx={{ mt: 3, justifyContent: "center" }}>
              <Button
                onClick={handleGoBack}
                variant="contained"
                startIcon={<ArrowBackRoundedIcon />}
                sx={{
                  backgroundColor: "#62666e",
                  ":hover": { backgroundColor: "#555" },
                  textTransform: "none",
                  borderRadius: 2,
                }}
              >
                Go Back
              </Button>

              <Button
                onClick={() => navigate('/')}
                variant="contained"
                startIcon={<HomeRoundedIcon />}
                sx={{
                  backgroundColor: "#00b97d",
                  ":hover": { backgroundColor: "#00a06b" },
                  textTransform: "none",
                  borderRadius: 2,
                }}
              >
                Go Home
              </Button>
            </Stack>

            {/* Security Notice */}
            <Box
              sx={{
                backgroundColor: "#f8faff",
                border: "1px solid #d0d8ff",
                borderRadius: 2,
                width: "100%",
                p: 2,
                mt: 3,
              }}
            >
              <Typography
                variant="body1"
                sx={{
                  color: "#2142c0",
                  lineHeight: 1.6,
                }}
              >
                <strong>Security Notice:</strong> This system handles sensitive
                medical data. Access is restricted based on your role and
                permissions. If you believe you should have access to this page,
                please contact your administrator.
              </Typography>
            </Box>
          </Stack>
        </Card>
      </Box>
    </Box>
  );
};

export default Unauthorized;
